import React from 'react';
import './style.css'; // Import the CSS file

const SalaryProgressBars = ({ baseSalary, netSalary }) => {
  // Calculate the percentage of net salary relative to base salary
  const salaryRatio = (netSalary / baseSalary) * 100;
  const changeAmount = netSalary - baseSalary;
  const isPositive = changeAmount >= 0;
  
  // For visual purposes, we'll show a bar that represents the change
  // If salary increased, bar goes beyond 100%
  // If salary decreased, bar stops before 100%
  const progressWidth = Math.min(Math.max(salaryRatio, 0), 120); // Cap at 120% for visual purposes
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="salary-progress-container">
      {/* Progress Bar Container */}
      <div className="progress-bar-wrapper">
        {/* Background bar (represents base salary) */}
        <div className="progress-bar-background">
          {/* Animated progress bar */}
          <div 
            className={`progress-bar-fill ${isPositive ? 'positive' : 'negative'}`}
            style={{ width: `${progressWidth}%` }}
          >
            {/* Shimmer effect */}
            <div className="progress-bar-shimmer"></div>
          </div>
          
          {/* 100% marker line */}
          <div className="progress-bar-marker"></div>
        </div>
        
        {/* Labels */}
        <div className="progress-labels">
          <span>Base: {formatCurrency(baseSalary)} dh</span>
          <span className={`final-salary ${isPositive ? 'positive' : 'negative'}`}>
            Final: {formatCurrency(netSalary)} dh
          </span>
        </div>
      </div>

      {/* Change indicator */}
      <div className="change-indicator">
        <div className={`change-badge ${isPositive ? 'positive' : 'negative'}`}>
          {isPositive ? '+' : ''}{formatCurrency(changeAmount)} dh 
          ({isPositive ? '+' : ''}{(salaryRatio - 100).toFixed(1)}%)
        </div>
      </div>
    </div>
  );
};

// Example usage component
const ExampleUsage = () => {
  const examples = [
    { name: "John Doe", baseSalary: 5000, netSalary: 4750 },
    { name: "Jane Smith", baseSalary: 6000, netSalary: 6200 },
    { name: "Mike Johnson", baseSalary: 4500, netSalary: 4200 },
    { name: "Sarah Wilson", baseSalary: 5500, netSalary: 5500 }, // No change
  ];

  return (
    <div className="example-container">
      <h2 className="example-title">Salary Change Progress Bars</h2>
      
      <div className="examples-list">
        {examples.map((employee, index) => (
          <div key={index} className="employee-card">
            <h3 className="employee-name">{employee.name}</h3>
            <SalaryProgressBars 
              baseSalary={employee.baseSalary} 
              netSalary={employee.netSalary} 
            />
          </div>
        ))}
      </div>

      {/* Usage Instructions */}
      <div className="usage-instructions">
        <h4 className="usage-title">How to use:</h4>
        <code className="usage-code">
          &lt;SalaryProgressBars baseSalary={`{5000}`} netSalary={`{4750}`} /&gt;
        </code>
      </div>
    </div>
  );
};

export default SalaryProgressBars;